export default "__VITE_ASSET__CZTP0rSw__";